import axios from "axios";
import { getToken } from "./authUtils";

export const imageBaseURL =
  "https://onezo.in/edu/qp/";

// Create an axios instance with the default headers
const api = axios.create({


baseURL: "https://onezo.in/edu/qp/controller/",
// baseURL: "https://devpanel.online/school_api/qb/controller/",


  // baseURL: "https://devpanel.online/sar-qp/controller_onezo", // Your base API URL/

  // imgUrl: "https://onezo.in/edu/qp/",


  
});

// Add the Authorization header to each request
api.interceptors.request.use(
  (config) => {
    const token = getToken(); // Get the token from localStorage
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`; // Set the token in the Authorization header
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;
